/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { Page } from '../../models/page';
import { PageApiRespModel } from '../../models/page-api-resp-model';

export interface ApiMasterPageAddPost$Params {
      body?: Page
}

export function apiMasterPageAddPost(http: HttpClient, rootUrl: string, params?: ApiMasterPageAddPost$Params, context?: HttpContext): Observable<StrictHttpResponse<PageApiRespModel>> {
  const rb = new RequestBuilder(rootUrl, apiMasterPageAddPost.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<PageApiRespModel>;
    })
  );
}

apiMasterPageAddPost.PATH = '/api/Master/Page/Add';
